<template>
  <div class="searchItem" v-if="contragentCategories.length > 0 && vocabCategories.total > 0">
    <div class="searchItemTitle">{{ $t('Категории закупок') }}</div>
    <div>
      <v-checkbox
        v-model="onlyMyCategories"
        :label="$t('Только по моим категориям')"
        :true-icon="'mdi-check mdi-18px'"
        :false-icon="'voidCheckbox'"
        color="primary"
        hide-details
        class="procedureStepCheckbox"
        @change="change"
      />
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: 'ProcedureCategories',
  props: {
    contragent: {
      type: Object,
      required: true
    },
    searchParams: {
      type: Object,
      required: true
    },
    search: {
      type: Function,
    }
  },
  data() {
    return {
      onlyMyCategories: true,
      vocabCategories: [],
      contragentCategories: []
    }
  },
  methods: {
    async change() {
      if (this.onlyMyCategories) {
        const { categories } = await api.get(`/profile/contragent/${this.contragent?.id}/load`);
        this.contragentCategories = categories;
        this.searchParams.categories = categories.map(c => c.id);
      } else {
        this.searchParams.categories = [];
      }
    }
  },
  async created() {
    this.vocabCategories = await api.get('/vocab/categories');    
    if (this.vocabCategories.total > 0) {
      await this.change();
      this.$emit('search');
    }
  }
}
</script>

<style scoped lang="scss">
:deep(.v-input--density-default) {
  --v-input-control-height: auto;
}
:deep(.v-selection-control--density-default) {
  --v-selection-control-size: 30px;
}
:deep(.procedureStepCheckbox .v-label) {
  color: rgb(var(--black-color));
  font-family: Abrade;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  opacity: 1;
  padding-left: 13px;
}
:deep(.mdi-check.mdi-18px) {
  border-radius: 3px;
  border: 1px solid rgba(var(--black-color), 0.3);
}
:deep(.voidCheckbox) {
  border-radius: 3px;
  border: 1px solid rgba(var(--black-color), 0.3);
  background-color: rgb(var(--white-color));
}
</style>